import '../scss/main.scss';

$(document).ready(function() {
    // hamburger menu
    $('.hamburger').on('click', function() {
        $('.header_nav').toggleClass('active');
        $('.hamburger').toggleClass('active');
        $('body').toggleClass('no-scroll');
      });

    // header scroll
    const $header = $('header');

    // footer accordion
    function initFooterToggle() {
    const $menu = $('.footer_nav > ul > li');
    
    $('a[href*="#"]').on('click', function(e) {
        var href = $(this).attr('href');
        var hash = href.split('#')[1];
        if (!hash) return;
        var $target = $('#' + hash);
        if ($target.length) {
            e.preventDefault();
            // ハンバーガーメニューを閉じる
            $('.header_nav').removeClass('active');
            $('.hamburger').removeClass('active');
            $('body').removeClass('no-scroll');
            // スクロール実行
            var headerHeight = $('header').outerHeight();
            var targetPos = $target.offset().top - headerHeight;
            $('html, body').animate({
                scrollTop: targetPos
            }, 500);
        }
    });
    // 既存のイベントを一旦削除（リサイズ時の多重バインド防止）
    $menu.off('click.footerToggle');

    if (window.matchMedia('(max-width: 765px)').matches) {
        $menu.on('click.footerToggle', function(e) {
        if ($(e.target).is('a')) return;
        $(this).toggleClass('open');
        $(this).children('.child').stop().slideToggle(300);
        });
    }
    }

    // 初回実行
    initFooterToggle();

    // 画面幅が変わったときも切り替え
    $(window).on('resize', function() {
        clearTimeout(window._footerResizeTimer);
        window._footerResizeTimer = setTimeout(initFooterToggle, 200);
    });


    window.addEventListener('scroll', function() {
        let scrollPos = window.scrollY || document.documentElement.scrollTop;
        if (scrollPos > 100) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    }, { passive: true });

    $(window).on('scroll', function() {
        // スクロールアニメーションの追加
        $('.flip-in, .under-in, .roll-in').each(function() {
          var elementTop = $(this).offset().top;
          var viewportBottom = $(window).scrollTop() + $(window).height();
          if (elementTop < viewportBottom - 200) {
              $(this).addClass('visible');
          }
        });
    });

    // モバイル用
    window.addEventListener('touchmove', function() {
        // 必要に応じて処理を追加
    }, { passive: true });
});